import { gql } from "@apollo/client";
import { COMPLAINT_FIELDS } from "../queries/complaints";

export const CREATE_COMPLAINT = gql`
  ${COMPLAINT_FIELDS}
  mutation CreateComplaint($input: ComplaintInput!) {
    createComplaint(input: $input) {
      ...complaintFields
    }
  }
`;

export const UPDATE_COMPLAINT = gql`
  ${COMPLAINT_FIELDS}
  mutation UpdateComplaint($input: ComplaintInput!) {
    updateComplaint(input: $input) {
      ...complaintFields
    }
  }
`;

export const UPDATE_COMPLAINT_STATUS = gql`
  ${COMPLAINT_FIELDS}
  mutation UpdateComplaintStatus($input: UpdateComplaintStatusInput!) {
    updateComplaintStatus(input: $input) {
      ...complaintFields
    }
  }
`;
